import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    Cells,
    Cell,
    CellHeader,
    CellBody,
    CellFooter,
    LoadMore,
} from 'react-weui';
import {renderMoney} from '../../utils';

import '../../styles/transactionrecord/TransactionRecordList.css';

class TransactionRecordList extends Component {
    constructor() {
        super();

        this.state = {
            icons: {
                'reward': 'icon-dashang icon-yellow',
                'reward_commission': 'icon-dashang icon-yellow',
                'pay_lecture': 'icon-kecheng icon-orange',
                'pay_lecture_resell': 'icon-fenxiao icon-green',
                'pay_lecture_relay': 'icon-gubo icon-blue',
                'pay_channel': 'icon-guihuazhuanti icon-red',
                'pay_channel_relay': 'icon-gubo icon-blue',
                'pay_channel_resell': 'icon-fenxiao icon-green',
                'subscribe_relay': 'icon-gubo icon-blue',
                'redpack': 'icon-hongbao1 icon-redpack',
                'return_redpack': 'icon-hongbao1 icon-redpack',
                'withdraw': 'icon-tixian icon-withdraw',
                'withdraw_fail': 'icon-tixian icon-withdraw',
                'refund': 'icon-tuikuan icon-refund',
                'user_refund': 'icon-tuikuan icon-refund',
                'weike_change': 'icon-qianbao icon-weike-change',
                'liveroom_vip': 'icon-vip icon-liveroom-vip',
                'relay': 'icon-gubo icon-blue',
                'gift_lecture': 'icon-lipin icon-yellow',
                'gift_channel': 'icon-lipin icon-yellow',
                'relay_channel': 'icon-gubo icon-blue',
                'liveroom_vip_resell': 'icon-fenxiao icon-green',
            }
        };

        this.handleMoreData = this.handleMoreData.bind(this);
    }

    handleMoreData() {
        const {loadData, offset, filterKey} = this.props;
        loadData(filterKey, offset);
    }

    render() {
        const {records, hasMore, loading} = this.props;
        const {icons} = this.state;

        return (
            <div className="transaction-record-list">
                <Cells>
                    {records.map((item, index) => (
                        <Cell key={item.id}>
                            <CellHeader>
                            <span className="span-icon-font">
                            { this.state.icons[item.type] ?
                                <i className={"iconfont " + icons[item.type]}/>
                                :
                                <i className="iconfont icon-gubo icon-blue"/>
                            }
                            </span>
                            </CellHeader>
                            <CellBody>
                                <div className="transaction-record-content">
                                    <span className="transaction-record-title">{item.name}-{item.description}</span>
                                    <span className="transaction-record-time">{item.create_time}</span>
                                </div>
                            </CellBody>
                            <CellFooter>
                                {item.change > 0 ?
                                    <span
                                        className="transaction-record-number plus">{"+" + renderMoney(item.change)}</span>
                                    :
                                    <span className="transaction-record-content jian">{renderMoney(item.change)}</span>
                                }
                            </CellFooter>
                        </Cell>
                    ))}

                    <Cell className="bt-foot">
                        {hasMore ?
                            loading ?
                                <LoadMore loading>正在加载</LoadMore>
                                :
                                <a className="transaction-record-bt text-center more" onClick={this.handleMoreData}>查看更多</a>
                            :
                            <div className="transaction-record-bt text-center">--没有更多--</div>
                        }
                    </Cell>
                </Cells>
            </div>
        );
    }
}

export default connect((state) => ({
    records: state.transactionRecord.records,
    hasMore: state.transactionRecord.has_more,
    filterKey: state.transactionRecord.filterKey,
    offset: state.transactionRecord.next_offset,
}))(TransactionRecordList)





// WEBPACK FOOTER //
// ./src/components/transactionrecord/TransactionRecordList.js